<template>
  <span>
    <h3 class="ma-0 pa-0">Case Information</h3>
    <v-row>
      <v-col cols="12" md="4" lg="4" xl="4">
        <!-- Reason for encounter -->
        <v-select v-model="form.reason" :items="reasonItems" placeholder=" ">
          <template v-slot:label>
            <span class="font-weight-bold primary--text"
              >Reason for encounter</span
            >
          </template>
        </v-select>
      </v-col>
      <v-col cols="12" md="4" lg="4" xl="4">
        <!-- Case Category -->
        <v-select
          v-model="form.category"
          :items="categoryItems"
          placeholder=" "
        >
          <template v-slot:label>
            <span class="font-weight-bold primary--text">Case Category</span>
          </template>
        </v-select>
      </v-col>
      <v-col cols="12" md="4" lg="4" xl="4">
        <!-- Sub-category -->
        <v-select v-model="form.sub" :items="categoryItems" placeholder=" ">
          <template v-slot:label>
            <span class="font-weight-bold primary--text">Sub-category</span>
          </template>
        </v-select>
      </v-col>
    </v-row>
  </span>
</template>

<script>
export default {
  props: {
    form: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data: () => ({
    reasonItems: ["Cough", "Fever", "High Blood Pressure"],
    categoryItems: ["Respiratory", "Circulatory", "Musculoskeletal"],
  }),
};
</script>